import { render, staticRenderFns } from "./ListProxy.vue?vue&type=template&id=5700e736&"
import script from "./ListProxy.vue?vue&type=script&lang=js&"
export * from "./ListProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports